import { ROUTES } from '@/app/config/constants';

/** Where the Supplier Dashboard lives (2026-10-29, NB-637): the supplier's home. */
export const supplierDashboardPaths = {
  dashboard: ROUTES.SUPPLIER_DASHBOARD,
};
